import React, { useContext } from 'react';
import styles from './DataConsentQuestion.module.sass';
import  AppContext  from '../../contexts/appContext';


const DataConsentQuestion = ({ marginBottom, marginRight }) => {
  const context = useContext(AppContext);
  return (
    <p
      marginBottom={marginBottom}
      marginRight={marginRight}
      onClick={() => context.setContext({...context, showLgpd: true })}
      className={styles.consentQuestion}
    >
      <i className="icon icon-info-p" />
      Como meus dados pessoais são usados?
    </p>
  );
};

export default DataConsentQuestion;
